import { Component, OnInit } from '@angular/core';
import { CookieConsentService } from '@plys/src/application/services/cookie-consent.service';

@Component({
  selector: 'plys-cookie-consent-banner',
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.scss'],
})
export class CookieConsentBannerComponent implements OnInit {
  showBanner = false;

  constructor(private cookieConsentService: CookieConsentService) {}

  ngOnInit(): void {
    this.showBanner = !this.cookieConsentService.hasConsent();
  }

  acceptAll(): void {
    this.cookieConsentService.acceptAll();
    this.showBanner = false;
  }

  acceptNecessaryOnly(): void {
    this.cookieConsentService.acceptNecessaryOnly();
    this.showBanner = false;
  }
}
